import { FC } from 'react'
import { AGBModal } from './AGB'
import { TermsConditions } from '.'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useOpenModal } from 'featureSliced/shared/hooks/useOpenModal'
import { CheckBox } from 'featureSliced/entities/CheckBox'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'

type TermsAndConditionsCheckboxProps = {
  isChecked: boolean
  handleCheck: (value: boolean) => void
}

export const TermsAndConditionsCheckbox: FC<
  TermsAndConditionsCheckboxProps
> = ({ isChecked, handleCheck }) => {
  const { CompanyName } = useMySelector((state) => state.app.companyData)
  const openModal = useOpenModal()
  const t = useTranslations()

  const openAGB = (e: any) => {
    e.stopPropagation()
    openModal({
      id: 'AGB_MODAL',
      title: t('sidebar.termsAndConditions'),
      components: [() => <AGBModal />],
    })
  }

  const openTermsAndConditions = (e: any) => {
    e.stopPropagation()
    openModal({
      id: 'TERMS_AND_CONDITIONS',
      title: t('sidebar.generalTermsAndConditions'),
      components: [() => <TermsConditions />],
    })
  }

  return (
    <CheckBox
      isChecked={isChecked}
      onClick={handleCheck}
      // TODO: translations
      label={
        <p>
          Mit Ihrer Bestellung stimmen Sie{' '}
          <b aria-hidden="true" onClick={openAGB}>
            den AGB
          </b>{' '}
          zu und bestatigen die{' '}
          <b aria-hidden="true" onClick={openTermsAndConditions}>
            Datenschutzerklarung
          </b>{' '}
          von {CompanyName || 'Muster'} zur Kenntnis genommen zu haben.
        </p>
      }
    />
  )
}
